<template>
  <div :class="flexClasses">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    gap: {
      type: Number,
      required: false,
    },
    isColumn: {
      type: Boolean,
      required: false,
    },
    isWrapping: {
      type: Boolean,
      required: false,
    },
    isYCentered: {
      type: Boolean,
      required: false,
    },
    isXCentered: {
      type: Boolean,
      required: false,
    },
    isBetween: {
      type: Boolean,
      required: false,
    },
    yAlign: {
      type: String,
      required: false,
    },
    xAlign: {
      type: String, // "right" or "left"
      required: false,
    },
    isFullWidth: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    flexClasses() {
      const getClasses = () => {
        const classes = new Set(['flex']);

        // Modifiers
        const isColumn = !!this.isColumn;
        const isYCentered = !!this.isYCentered;
        const isXCentered = !!this.isXCentered;
        const isWrapping = !!this.isWrapping;
        const isFullWidth = !!this.isFullWidth;

        if (isColumn) classes.add('flex-column');
        if (isYCentered) classes.add('flex-y-center');
        if (isXCentered) classes.add('flex-x-center');
        if (isWrapping) classes.add('flex-wrap');
        if (isFullWidth) classes.add('flex-w100');

        // X align
        const isXRight = this.xAlign === 'right';
        const isXLeft = this.xAlign === 'left';
        const isXCenter = this.xAlign === 'center';
        const isBetween = !!this.isBetween;

        if (isBetween) classes.add('space-between');
        if (isXRight) classes.add('flex-right');
        if (isXLeft) classes.add('flex-left');
        if (isXCenter) classes.add('flex-x-center');

        // Y align
        const isYBaseline = this.yAlign === 'baseline';
        if (isYBaseline) classes.add('flex-baseline');

        // Gap
        const gap = this.gap || 0;
        if (!!gap) classes.add(`flex-gap-${gap}`);

        return [...classes].join(' ');
      };

      return getClasses();
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
}

.flex-column {
  flex-direction: column;
}

.flex-wrap {
  flex-wrap: wrap;
}

.flex-baseline {
  align-items: baseline;
}

.flex-left {
  justify-content: flex-start;
}

.flex-right {
  justify-content: flex-end;
}

.space-between {
  justify-content: space-between;
}

.flex-y-center {
  align-items: center;
}

.flex-x-center {
  justify-content: center;
}

.flex-w100 {
  /* NOTE @chris Coming from vuetify. */
  flex-grow: 0 !important;
  flex-shrink: 0 !important;
  width: 100%;
}

/* NOTE @chris These are intentional constraints to help vertical rythm. */
.flex-gap-1 {
  gap: 1px;
}
.flex-gap-2 {
  gap: 2px;
}
.flex-gap-4 {
  gap: 4px;
}
.flex-gap-6 {
  gap: 6px;
}
.flex-gap-8 {
  gap: 8px;
}
.flex-gap-12 {
  gap: 12px;
}
.flex-gap-16 {
  gap: 16px;
}
.flex-gap-20 {
  gap: 20px;
}
.flex-gap-24 {
  gap: 24px;
}
.flex-gap-28 {
  gap: 28px;
}
.flex-gap-32 {
  gap: 32px;
}
.flex-gap-36 {
  gap: 36px;
}
</style>
